import { IFilter } from "@api";

export const buildFilterQuery = (filter: IFilter = {}) => {
    const q = filter.q ? `q=${filter.q}` : undefined;
    const sort_by = filter.sort_by ? `sort_by=${filter.sort_by}` : "";
    const order = filter.order ? `order=${filter.order}` : "";
    return [q, sort_by, order].filter(Boolean).join("&");
};
